import React, {Component} from "react"
import PropTypes from "prop-types"

import Loading from "@irati/ui/src/Loading"
import productSettingsService from "@irati/permissions/services/productSettings"
import authentication from "@irati/auth"

import {Business, ProductSettingsRecognitionValuesByRank, ProductSettingsWallet} from "@irati/types"
import {hangPromise} from "@irati/utils/promise"
import {H1} from "@irati/ui/src/Typography"
import {QueryOptions} from "@irati/utils/services/apollo"
import {FormattedMessage} from "@irati/utils/lang"
import devToggles from "@irati/dev-toggles"
import BuyPointsOptions from "./BuyPointsOptions"
import RequestPointsOptions from "./RequestPointsOptions"
import ApproveRequestPointsOptions from "./ApproveRequestPointsOptions"
import {RewardMinMaxSettings} from "./RewardSettings/RewardMinMaxSettings"

const purchasePointsOptions = [
  {value: ProductSettingsRecognitionValuesByRank.TeamLeaderAndManager, label: "admin.permissions.poll.adminAndManagerDefault"},
  {value: ProductSettingsRecognitionValuesByRank.TeamLeaderOnly, label: "admin.permissions.poll.adminOnly"}
]
const requestPointsOptions = [
  {value: ProductSettingsRecognitionValuesByRank.Off, label: "admin.permissions.poll.offDefault"},
  {value: ProductSettingsRecognitionValuesByRank.TeamLeaderAndManager, label: "admin.permissions.poll.adminAndManager"},
  {value: ProductSettingsRecognitionValuesByRank.TeamLeaderOnly, label: "admin.permissions.poll.adminOnly"}
]
const approvePointsOptions = [
  {value: ProductSettingsRecognitionValuesByRank.Off, label: "admin.permissions.poll.offDefault"},
  {value: ProductSettingsRecognitionValuesByRank.TeamLeaderOnly, label: "admin.permissions.poll.adminOnly"}
]
interface Props {}

interface State {
  canPurchasePoints?: ProductSettingsWallet["canPurchasePoints"]
  canRequestPoints?: ProductSettingsWallet["canRequestPoints"]
  canApprovePointsRequest?: ProductSettingsWallet["canApprovePointsRequest"]
  load: Promise<any>
}

class WalletSettings extends Component<Props> {
  static propTypes = {
    auth: PropTypes.object.isRequired
  }

  state: State = {
    load: hangPromise()
  }

  componentDidMount() {
    this.setState({load: this.getWalletPermissions(authentication.business())})
  }

  getWalletPermissions = async (business: Business, options?: QueryOptions) => {
    const ps = await productSettingsService.get(business.uuid, business.rootTeamId, options)

    const {canPurchasePoints, canApprovePointsRequest, canRequestPoints} = ps.walletSettings || {}

    this.setState({
      canPurchasePoints,
      canRequestPoints,
      canApprovePointsRequest
    })
  }

  onUpdate() {
    this.getWalletPermissions(authentication.business(), {fetchPolicy: "network-only"})
  }

  render() {
    const {canPurchasePoints, canRequestPoints, canApprovePointsRequest, load} = this.state

    return (
      <>
        <H1 marginBottom={2}>
          <FormattedMessage id="admin.settings.rewards.title" />
        </H1>
        <Loading load={load}>
          <BuyPointsOptions
            options={purchasePointsOptions}
            value={canPurchasePoints || ProductSettingsRecognitionValuesByRank.TeamLeaderAndManager}
            onUpdate={this.onUpdate.bind(this)}
          />
          <RequestPointsOptions
            options={requestPointsOptions}
            value={canRequestPoints || ProductSettingsRecognitionValuesByRank.Off}
            onUpdate={this.onUpdate.bind(this)}
          />
          <ApproveRequestPointsOptions
            options={approvePointsOptions}
            value={canApprovePointsRequest || ProductSettingsRecognitionValuesByRank.Off}
            onUpdate={this.onUpdate.bind(this)}
          />
          {devToggles.showRewardMinMaxSettings() && <RewardMinMaxSettings />}
        </Loading>
      </>
    )
  }
}

export default WalletSettings
